import * as moment from 'moment';
import { CalendarEvent } from './calendarEvent.model';
import { Group } from './group.model';

export class Event {
    constructor(json?: any) {
        this.id = json && json.id || null;
        this.eventName = json && json.event_name || null;
        this.eventDate = json && json.event_date || null;
        this.eventImageURL = json && json.event_image_url || null;
        this.eventDescription = json && json.event_description || null;
        this.eventCreatorID = json && json.event_creator_id || null;
        this.eventCreatorFirstName = json && json.event_creator_first_name || null;
        this.eventCreatorLastName = json && json.event_creator_last_name || null;
        this.eventTypeID = json && json.event_type_id || null;
        this.eventEndDate = json && json.event_end_date || null;
        this.reminderTime = json && json.reminder_time || null;
        this.eventTypeName = json && json.event_type_name || null;
        this.isClosed = json && json.event_is_closed || null;
        this.allDay = json && json.event_all_day || null;
        this.location = json && json.location || null;
        this.portalID = json && json.portal_id || null;
        this.portalName = json && json.portal_name || null;
        this.portalLogo = json && json.portal_logo|| null;
        this.groupID = json && json.group_id || null;
        this.groupName = json && json.group_name || null;
        this.isPersonal = json && json.is_personal !== null ? json.is_personal : false
        this.isDeleted = json && json.is_deleted || false;

        if (this.isPersonal) {
          this.visibility = "personal";
        } else {
          this.visibility = "portal";
        }

        if(this.eventDate) {
          if (this.allDay) {
            this.momentEventDate = moment.utc(this.eventDate);
            this.startDate = moment.utc(this.eventDate).format('YYYY-MM-DDTHH:mmZ');
          } else {
            this.momentEventDate = moment(this.eventDate);
            this.startDate = moment(this.eventDate).format('YYYY-MM-DDTHH:mmZ');
          }
        }

        if(this.eventEndDate) {
          if (this.allDay) {
            this.momentEventEndDate = moment.utc(this.eventEndDate);
            this.endDate = moment.utc(this.eventEndDate).format('YYYY-MM-DDTHH:mmZ');
          } else {
            this.momentEventEndDate = moment(this.eventEndDate);
            this.endDate = moment(this.eventEndDate).format('YYYY-MM-DDTHH:mmZ');
          }
        }

        if(this.reminderTime) {
          if (this.allDay) {
            this.momentReminderTime = moment.utc(this.reminderTime);
          } else {
            this.momentReminderTime = moment(this.reminderTime);
          }
        }

        if (this.momentEventDate && this.momentReminderTime) {
          // Calculate the difference in minutes between startDate and reminderTime to get the reminder interval
          let duration = moment.duration(this.momentEventDate.diff(this.momentReminderTime));
          this.selectedReminder = duration.asMinutes();
        }

        this.attendingEvent = false;

        this.groups = [];
        this.selectedGroups = [];
        if (json && json.groups) {
          json.groups.forEach(group => {
            this.groups.push(new Group(group));
            this.selectedGroups.push(group.id);
          });
        }
    }

    id: number;
    eventName: string;
    eventDate: string;
    eventImageURL: string;
    eventDescription: string;
    eventCreatorID: number;
    eventCreatorFirstName: string;
    eventCreatorLastName: string;
    eventTypeID: number;
    eventEndDate: string;
    reminderTime: string;
    eventTypeName: string;
    isClosed: boolean;
    allDay: boolean;
    location: string;
    portalID: number
    portalName: string;
    portalLogo: string;
    groupID: number;
    groupName: string;
    isPersonal: boolean;
    visibility: string;
    isDeleted: boolean;

    selectedGroups: number[];
    selectedReminder: number;

    startTime: Date;
    endTime: Date;

    startDate: string;
    endDate: string;

    momentEventDate: moment.Moment;
    momentEventEndDate: moment.Moment;
    momentReminderTime: moment.Moment;

    attendingEvent: boolean;

    groups: Group[];

    toCalendarEvent(isMonthly?: boolean) : CalendarEvent {
      let newCalendarEvent = new CalendarEvent();
      newCalendarEvent.id = this.id;
      newCalendarEvent.title = this.eventName;
      newCalendarEvent.allDay = this.allDay;
      newCalendarEvent.location = this.location;
      newCalendarEvent.portalID = this.portalID;
      newCalendarEvent.portalLogo = this.portalLogo;
      newCalendarEvent.groups = this.groups;
      newCalendarEvent.eventType = "EVENT";

      let start = this.momentEventDate;
      let end = this.momentEventEndDate;

      newCalendarEvent.startTime = start.toDate();
      newCalendarEvent.endTime = end.toDate();

      newCalendarEvent.eventDate = start.toDate();
      newCalendarEvent.eventDate.setHours(0, 0, 0, 0);
      newCalendarEvent.eventEndDate = end.toDate();
      newCalendarEvent.eventEndDate.setHours(0, 0, 0, 0);

      if (this.allDay) {
        newCalendarEvent.endTime.setHours(newCalendarEvent.endTime.getHours() + 23);
        newCalendarEvent.endTime.setMinutes(newCalendarEvent.endTime.getMinutes() + 59);

        newCalendarEvent.eventDate = start.local(true).toDate();
        newCalendarEvent.eventDate.setHours(0, 0, 0, 0);
        newCalendarEvent.eventEndDate = end.local(true).toDate();
        newCalendarEvent.eventEndDate.setHours(0, 0, 0, 0);

      } else if (isMonthly && this.eventDate == this.eventEndDate) {
        newCalendarEvent.endTime.setHours(newCalendarEvent.endTime.getHours() + 1);
      }

      return newCalendarEvent;
    }

    copy() {
      let newEvent = new Event();

      newEvent.eventName = this.eventName;
      newEvent.eventDate = this.eventDate;
      newEvent.eventImageURL = this.eventImageURL;
      newEvent.eventDescription = this.eventDescription;
      newEvent.eventCreatorID = this.eventCreatorID;
      newEvent.eventCreatorFirstName = this.eventCreatorFirstName;
      newEvent.eventCreatorLastName = this.eventCreatorLastName;
      newEvent.eventTypeID = this.eventTypeID;
      newEvent.eventEndDate = this.eventEndDate;
      newEvent.reminderTime = this.reminderTime;
      newEvent.eventTypeName = this.eventTypeName;
      newEvent.isClosed = this.isClosed;
      newEvent.allDay = this.allDay;
      newEvent.location = this.location;
      newEvent.portalID = this.portalID;
      newEvent.portalName = this.portalName;
      newEvent.portalLogo = this.portalLogo;
      newEvent.groupID = this.groupID;
      newEvent.groupName = this.groupName;
      newEvent.isPersonal = this.isPersonal;
      newEvent.selectedGroups = this.selectedGroups
      newEvent.selectedReminder = this.selectedReminder;
      newEvent.visibility = this.visibility;

      newEvent.startDate = this.startDate;
      newEvent.endDate = this.endDate;

      return newEvent;
    }
}
